import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory, WelcomeCall } from "common";

@Injectable()
export class EntityWelcomeCallWidgetAdapter {
  constructor(
    private readonly datePipe: DatePipe
  ) { }

  adaptListData = (data: WelcomeCall): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Required',
        displayedValue: data?.required ? "Yes" : "No"
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Completed',
        displayedValue: data?.isComplete ? "Yes" : "No"
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Completed on',
        displayedValue: this.formatDate(data?.completedOn) || '-'
      }),
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'RingDNA link',
        customTemplateName: "ringDNALinkValue",
      }),
    ]
  }

  private formatDate(value: string): string {
    return this.datePipe.transform(value);
  }
}